import { render } from "./MainPage.vue?vue&type=template&id=53eab315&scoped=true"
const script = {}

import "./MainPage.vue?vue&type=style&index=0&id=53eab315&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eab315"]])

export default __exports__